::ng-deep mat-radio-button{margin-left:1rem}
/*# sourceMappingURL=select-data-mapping-source-dialog.component-CJK6FECD.css.map */
